<style>
  .tooltip {
    position: relative;
    display: inline-block;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    top: -5px;
    right: 110%;
  }

  .tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 100%;
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent transparent black;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }

  .count-btn {
    border-radius: 50px;
    padding: 5px 15px;
    font-weight: bold;
    margin-left: 10px;
  }
</style>
<template>
  <div>
    <!-- count section  -->
    <div>
      <div class="d-inline-block elevation-1 count-btn">
        <span> Total :</span> <span> {{ total_customer }}</span>
      </div>
      <div class="d-inline-block elevation-1 count-btn">
        <span> Leads :</span> <span> {{ total_leads }}</span>
      </div>
      <div class="d-inline-block elevation-1 count-btn">
        <span> Applied :</span> <span> {{ applied }}</span>
      </div>
      <div class="d-inline-block elevation-1 count-btn">
        <span> Approved :</span> <span> {{ approved }}</span>
      </div>
      <div class="d-inline-block elevation-1 count-btn">
        <span> Sanctioned :</span> <span> {{ sanctioned }}</span>
      </div>
      <div class="d-inline-block elevation-1 count-btn">
        <span> Disbursed :</span> <span> {{ disbursed }}</span>
      </div>
      <div class="d-inline-block elevation-1 count-btn">
        <span> Completed :</span> <span> {{ completed }}</span>
      </div>
      <div class="d-inline-block elevation-1 count-btn">
        <span> Rejected :</span> <span> {{ rejected }}</span>
      </div>
    </div>

    <!-- Filters. Rebuilt on the shared KarroFin FilterBar: same endpoint, same
         params, same Vuex module -- only the presentation moved. These seven
         controls used to sit permanently open above the table, so the list
         started most of a screen down. -->
    <FilterBar
      :show-search="false"
      :show-date="false"
      :advanced-count="activeChips.length"
      :rest-count="restCount"
      @change="getCustomerList(true)"
      @reset="resetFilters"
    >
      <template #actions>
        <v-btn
          v-if="$store.state.permission_list.includes($keys.EXPORT_CUSTOMER_CSV)"
          text
          small
          class="text-none kf-filter__reset"
          @click="downloadCsv"
        >
          <v-icon class="mr-1" small>mdi-download</v-icon>
          {{ $lang.EXPORT_CSV }}
        </v-btn>
      </template>

      <template v-for="f in filterLayout">
        <div
          :key="f.key"
          class="kf-field"
          :class="{ 'kf-field--rest': f.rest }"
        >
          <span class="kf-field__label">{{ f.label }}</span>

          <DateField
            v-if="f.key === 'date_range'"
            v-model="filters.date_range"
            range
            :max="today"
            @change="onDateChange()"
          />

          <DateField
            v-else-if="f.key === 'status_date_range'"
            v-model="filters.status_date_range"
            range
            :max="today"
            @change="onDateChange()"
          />

          <DateField
            v-else-if="f.key === 'follow_up_date'"
            v-model="filters.follow_up_date"
            @change="onDateChange()"
          />

          <v-select
            v-else-if="f.key === 'loan_steps'"
            v-model="filters.loan_steps"
            :items="loan_steps"
            placeholder="Any status"
            dense
            outlined
            single-line
            hide-details
            clearable
            @change="getCustomerList(true)"
          />

          <v-select
            v-else-if="f.key === 'profile_status'"
            v-model="filters.profile_status"
            :items="profile_status_list"
            placeholder="Any status"
            dense
            outlined
            single-line
            hide-details
            clearable
            @change="getCustomerList(true)"
          />

          <v-combobox
            v-else-if="f.key === 'current_city'"
            v-model="filters.current_city"
            :items="city_list"
            :loading="city_loading"
            :search-input.sync="city_search"
            placeholder="Any city"
            dense
            outlined
            single-line
            hide-details
            clearable
            @change="getCustomerList(true)"
            @focus="getCitylist()"
            @keyup="onCitySearch()"
          />

          <v-select
            v-else
            v-model="filters.source"
            :items="source_list"
            placeholder="Any source"
            dense
            outlined
            single-line
            hide-details
            clearable
            @change="getCustomerList(true)"
          />
        </div>
      </template>

      <!-- Chips say why the table is short. These filters live in Vuex and
           survive navigating away and back, so without them you could return to
           a filtered list with nothing on screen saying why. -->
      <template #chips>
        <v-chip
          v-for="c in activeChips"
          :key="c.key"
          small
          close
          class="kf-fchip"
          @click:close="clearFilter(c.key)"
        >
          <strong>{{ c.label }}:</strong>&nbsp;{{ c.value }}
        </v-chip>
      </template>
    </FilterBar>

    <v-card flat outlined>
      <v-data-table
        :disable-sort="true"
        :headers="headers"
        :items="itemsWithSno"
        :items-per-page="$keys.PAGE_LENGTH"
        :loading="table_loading"
        class="border-a border-0 custome-header-bg"
        hide-default-footer
      >
        <template v-slot:item.sno="{ item }">
          <p>{{ item.sno + (filters.page_number - 1) * $keys.PAGE_LENGTH }}</p>
        </template>

        <template v-slot:item.name="{ item }">
          <p class="pt-2">{{ item.name }}</p>
          <p class="pt-2">{{ item.mobile }}</p>
          <p class="pb-2">{{ item.email }}</p>
        </template>

        <template v-slot:item.referred_by="{ item }">
          <div v-if="item.referred_by">
            <p class="pt-2">{{ item.referred_by.name }}</p>
            <p class="pt-2">{{ item.referred_by.mobile }}</p>
          </div>
          <div v-else>-</div>
        </template>

        <template v-slot:item.action="{ item }">
          <div class="d-inline-block">
            <div>
              <v-btn
                color="secondary_2"
                fab
                small
                text
                @click="addComment(item)"
              >
                <v-icon>mdi-message-text-outline</v-icon>
              </v-btn>
            </div>
            <div v-if="item.unblock_kyc" class="tooltip">
              <v-btn
                color="secondary_2"
                fab
                small
                text
                @click="unLockKyc(item.customer_id)"
              >
                <v-icon>mdi-lock-open-variant-outline</v-icon>
              </v-btn>
              <span class="tooltiptext">Unlock the KYC attempts</span>
            </div>
          </div>
          <div
            :class="item.unblock_kyc ? 'pt-5' : ''"
            class="d-inline-block"
            style="vertical-align: top"
          >
            <v-btn
              :disabled="item.customer_id == '-' ? true : false"
              fab
              small
              text
              @click="gotoCustomerProfile(item)"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:item.loan_step="{ item }">
          <p v-if="item.loan_step == 'step_in_person_verification'">
            In video verification
          </p>
          <p v-else>
            {{
              item.loan_step
                .replace("step_", "")
                .charAt(0)
                .toUpperCase() +
                "" +
                item.loan_step
                  .replace("step_", "")
                  .replace(/_/g, " ")
                  .slice(1)
                  .toLowerCase()
            }}
          </p>
          <small v-if="item.action_date" class="pb-2">
            {{ item.action_date }}
          </small>
        </template>

        <template v-slot:item.follow_up_date="{ item }">
          <p v-if="item.follow_up_date">
            {{ new Date(item.follow_up_date).toDateString().slice(4) }}
          </p>
          <p v-else>-</p>
        </template>
      </v-data-table>
    </v-card>

    <v-pagination
      v-model="filters.page_number"
      :length="total_page_count"
      :total-visible="7"
      class="custome-pagination"
      @input="getCustomerList"
    ></v-pagination>

    <AddComments
      ref="comment_dialog"
      :dialog="comment_dialog"
      @update="getCustomerList"
    />
  </div>
</template>
<script>
import {
  getDefaultSignupDateRangeIso,
  formatSignupDateRangeDisplay,
} from "@/utils/defaultSignupDateRange";
  import { mapGetters } from "vuex";
  import fmt from "@/app-js/karrofin/format";
  import FilterBar from "@/components/karrofin/FilterBar.vue";
  import DateField from "@/components/karrofin/DateField.vue";

  /**
   * Every filter this screen has, in the order it appears -- most-used first.
   * The status-date range only applies once the loan-status tab is off Lead.
   * Anything past PRIMARY_SLOTS starts behind the "More filters" toggle.
   */
  const FILTER_ORDER = [
    { key: "date_range", label: "Signup date" },
    { key: "loan_steps", label: "Loan status" },
    { key: "profile_status", label: "Profile status" },
    { key: "current_city", label: "City" },
    { key: "follow_up_date", label: "Follow-up date" },
    { key: "source", label: "Lead source" },
    {
      key: "status_date_range",
      label: "Status date",
      show: (vm) => vm.isLoanStatusLead == false,
    },
  ];

  /** Filters shown before the "More filters" toggle -- one full grid row. */
  const PRIMARY_SLOTS = 4;

  export default {
    components: {
      FilterBar,
      DateField,
      AddComments: () => import("@/components/customer/dialog/AddComments"),
    },
    data() {
      return {
        table_loading: false,
        page_number: 1,
        total_page_count: 2,
        customer_list: [],
        total_customer: 0,
        total_leads: 0,
        applied: 0,
        approved: 0,
        sanctioned: 0,
        disbursed: 0,
        rejected: 0,
        completed: 0,
        source_list: [
          "Facebook Ads",
          "Google Ads",
          "Newspaper",
          "Friends & Relatives",
          "Hoardings",
          "Google Search",
          "Others",
        ],
        loan_status_list: [
          "Lead",
          "Applied",
          "Approved",
          "Sanctioned",
          "Disbursed",
          "Rejected",
          "Completed",
        ],
        profile_status_list: [
          "Signed in",
          "Basic info",
          "Address Details",
          "Reference Details",
          "Employer Details",
          "Bank Details",
          "Document Upload",
          "Profile Completed",
        ],
        headers: [
          { text: "SN", value: "sno" },
          {
            text: "CIF ID ",
            align: "start",
            filterable: false,
            value: "lms_customer_id",
          },
          { text: "Customer info", value: "name" },
          // {text: 'Mobile No.', value: 'mobile'},
          { text: "City", value: "current_city" },
          { text: "Type", value: "loan_step", width: "115px" },
          { text: "Profile Status", value: "user_profile_status" },
          { text: "Signup Date", value: "created" },
          { text: "Referred by", value: "referred_by" },
          { text: "Source", value: "where_did_you_know", align: "center" },
          { text: "Follow up date", value: "follow_up_date", align: "center" },
          { text: "Comment", value: "comment" },
          { text: "", value: "action", width: "115px" },
        ],
        loan_steps: [
          { name: "Lead", value: "Lead" },
          { name: "Applied", value: "Applied" },
          { name: "Document Verified", value: "Document Verified" },
          { name: "Approved", value: "Approved" },
          { name: "Sanctioned", value: "Sanctioned" },
          { name: "In Video Verification", value: "In Video Verification" },
          { name: "Setup Auto Debit", value: "Setup Auto Debit" },
          { name: "Money on the way", value: "Money on the way" },
          { name: "Disbursed", value: "Disbursed" },
          { name: "Repayment", value: "Repayment" },
          { name: "Completed", value: "Completed" },
          { name: "Rejected", value: "Rejected" },
        ],
        display_daterange: null,
        today: new Date().toISOString().substr(0, 10),
        city_list: [],
        city_search_query: "",
        city_loading: false,
        city_search: "",
        comment_dialog: {
          flag: false,
          comment: null,
          follow_up_date: null,
          label: null,
          id: null,
        },

        // for status date filter
        isLoanStatusLead: true,


      };
    },
    computed: {
      ...mapGetters({
        search_query: "getSearchText",
        filters: "customer/getFilters",
      }),
      /** The filters this user actually sees, with the overflow tagged. */
      filterLayout() {
        const shown = FILTER_ORDER.filter((f) => !f.show || f.show(this));
        return shown.map((f, i) => ({ ...f, rest: i >= PRIMARY_SLOTS }));
      },
      /** How many are hidden -- drives the More/Less button and its badge. */
      restCount() {
        return this.filterLayout.filter((f) => f.rest).length;
      },
      /**
       * One entry per applied filter, for the chip row -- the only thing on the
       * page that says what is filtering the list while the grid is collapsed.
       */
      activeChips() {
        const chips = [];
        const f = this.filters;
        const push = (key, label, value) => chips.push({ key, label, value });

        const signup = f.date_range;
        if (Array.isArray(signup) && signup.length === 2 && signup[0] && signup[1]) {
          push("date_range", "Signup date", fmt.dateRangeShort(signup[0], signup[1]));
        }
        const status = f.status_date_range;
        if (Array.isArray(status) && status.length === 2 && status[0] && status[1]) {
          push(
            "status_date_range",
            "Status date",
            fmt.dateRangeShort(status[0], status[1])
          );
        }
        if (f.loan_steps) push("loan_steps", "Loan status", f.loan_steps);
        if (f.profile_status) {
          push("profile_status", "Profile status", f.profile_status);
        }
        if (f.current_city) push("current_city", "City", f.current_city);
        if (f.follow_up_date) {
          push("follow_up_date", "Follow-up date", f.follow_up_date);
        }
        if (f.source) push("source", "Lead source", f.source);
        return chips;
      },
      itemsWithSno() {
        return this.customer_list.map((d, index) => ({ ...d, sno: index + 1 }));
      },
    },
    watch: {
      search_query(new_search_query, old_search_query) {
        this.getCustomerList(true);
        // console.log(new_search_query, old_search_query, "ABORT");
        // console.log(new_search_query.includes(old_search_query));
        // if (!old_search_query) {
        //   this.getCustomerList();
        // } else if (
        //   new_search_query != old_search_query &&
        //   !new_search_query.includes(old_search_query)
        // ) {
        //   console.log("CALLED");
        //   this.getCustomerList(true);
        // }
      },
    },

    created() {
      console.log(this.$route.meta.show_back_btn);
      this.getCustomerList(true);
    },

    methods: {
      /** Keeps the module's `display_*` labels in step with the raw ranges. */
      onDateChange() {
        const f = this.filters;
        if (f.date_range && f.date_range.length > 1) {
          f.display_daterange = this.formateDisplayDateRange(f.date_range);
        }
        if (f.status_date_range && f.status_date_range.length > 1) {
          f.display_status_daterange = this.formateDisplayDateRange(
            f.status_date_range
          );
        }
        if (f.follow_up_date) {
          f.fd_display_date = this.display_date_formate(f.follow_up_date);
        }
        this.getCustomerList(true);
      },
      /** One chip's x. */
      clearFilter(key) {
        const f = this.filters;
        if (key === "date_range") {
          f.date_range = [];
          f.display_daterange = "";
        } else if (key === "status_date_range") {
          f.status_date_range = [];
          f.display_status_daterange = "";
        } else if (key === "follow_up_date") {
          f.follow_up_date = null;
          f.fd_display_date = null;
        } else {
          f[key] = null;
        }
        f.page_number = 1;
        this.getCustomerList(true);
      },
      /** Clears every filter, including the ones behind the toggle. */
      resetFilters() {
        const f = this.filters;
        const range = getDefaultSignupDateRangeIso();
        f.date_range = range;
        f.display_daterange = formatSignupDateRangeDisplay(range);
        f.status_date_range = [];
        f.display_status_daterange = "";
        f.follow_up_date = null;
        f.fd_display_date = null;
        f.loan_steps = null;
        f.profile_status = null;
        f.current_city = "";
        f.source = null;
        f.page_number = 1;
        this.getCustomerList(true);
      },
      /* fetching the customer list form server*/
      getCustomerList(isCancel = false) {
        const self = this;
        self.table_loading = true;
        self.toggle_loading();

        // for status date filter
        let step_status =  this.filters.loan_steps
            ? "step_" + this.filters.loan_steps.replace(/ /g, "_").toLowerCase()
            : null;

            // console.log("step",step_status)
        
        if(step_status == null || step_status == "step_lead"){
          this.isLoanStatusLead = true
          this.daterange = [];
          this.filters.display_status_daterange = null;
          this.filters.status_date_range = []
        }
        if(step_status != "step_lead" && step_status != null){
          this.isLoanStatusLead = false;

        }

        let params = {
          page_number: this.filters.page_number,
          page_length: this.$keys.PAGE_LENGTH,
          search_query: this.search_query,
          loan_status: this.filters.loan_status,
          loan_step: this.filters.loan_steps
            ? "step_" + this.filters.loan_steps.replace(/ /g, "_").toLowerCase()
            : null,
          user_profile_status: this.filters.profile_status,
          from_date: this.filters.date_range[0],
          to_date: this.filters.date_range[1],
          // for status date filter
          created_from: this.filters.status_date_range[0],
          created_till: this.filters.status_date_range[1],

          city: this.filters.current_city,
          follow_up_date: this.filters.follow_up_date,
          where_did_you_know: this.filters.source,
          label: this.filters.label,
        };

        console.log(params);
        const successHandler = (response) => {
          self.customer_list = [];
          self.table_loading = false;
          if (response.data.success) {
            self.customer_list = response.data.customer_list;
            self.total_page_count = response.data.total_page_count;
            self.total_customer = response.data.total_customer;
            self.total_leads = response.data.Lead;
            self.applied = response.data.applied_loan;
            self.approved = response.data.Approved;
            self.sanctioned = response.data.Sanctioned;
            self.disbursed = response.data.Disbursed;
            self.completed = response.data.Completed;
            self.rejected = response.data.Rejected;
          }
        };
        const finallyHandler = () => {
          self.table_loading = false;
        };

        self.request_GET(
          self,
          self.$urls.CUSTOMER_LIST,
          params,
          successHandler,
          null,
          null,
          finallyHandler,
          isCancel
        );
      },
      /* fetching the cit list form server*/
      /*
       * Fetching the city list from the server.
       *
       * No paging, and no infinite scroll, because the endpoint has none:
       * webpanel.apis.get_city_list reads `page_number` into a local and never uses
       * it -- it always returns the first 200 divisions matching the search. So
       * every "next page" returned the SAME 200 rows, and the append branch
       * concatenated them again.
       *
       * That was worse than it sounds. The template wired this as
       * `@keyup="getCitylist"`, and a bare method reference in a Vue DOM handler
       * receives the native event as its first argument -- always truthy -- so
       * `append_city` was true on every keystroke. Typing a six-letter city name
       * appended those same 200 rows six times over.
       *
       * The search box already narrows server-side (division__icontains), which is
       * what actually makes this list usable.
       */
      /**
       * Debounced lookup: this was bound straight to @keyup, firing one
       * request per keystroke. 350 ms matches the interval used by FilterBar
       * and the other list screens.
       */
      onCitySearch() {
        clearTimeout(this._cityLookupTimer);
        this._cityLookupTimer = setTimeout(() => this.getCitylist(), 350);
      },
      getCitylist() {
        const self = this;
        self.city_loading = true;
        let params = {
          search_query: this.city_search,
        };
        console.log(params);
        const successHandler = (response) => {
          if (response.data.success) {
            self.city_list = response.data.city_list;
          }
        };
        const finallyHandler = () => {
          self.city_loading = false;
        };

        self.request_GET(
          self,
          self.$urls.CITY_LIST,
          params,
          successHandler,
          null,
          null,
          finallyHandler
        );
      },
      gotoCustomerProfile(customer) {
        // this.$router.push({
        //   name: "customer-details",
        //   params: {
        //     id: this.encript(customer.customer_id),
        //   },
        // });
        
      // redirect to new customer details page
      this.$router.push({
        name: "customer-details",
        params: {
          id: this.encript(customer.customer_id),
        },
      });
      },
      formateDisplayDateRange(daterange) {
        console.log(daterange);
        let date1 = daterange[0];
        let date2 = daterange[1];
        let to = "";
        let from = "";
        if (date1 > date2) {
          to = date1;
          from = date2;
        } else {
          to = date2;
          from = date1;
        }
        console.log(from);
        if (!to) to = from;
        daterange[0] = from;
        daterange[1] = to;
        from = this.display_date_formate(from);
        to = this.display_date_formate(to);
        return `${from} to ${to}`;
      },
      addComment(item) {
        this.comment_dialog.comment = item.comment == " - " ? "" : item.comment;
        this.comment_dialog.id = item.customer_id;
        this.comment_dialog.follow_up_date = item.follow_up_date;
        this.comment_dialog.label = item.label;
        this.comment_dialog.flag = true;
        this.$refs.comment_dialog.formateDisplayDate();
      },
      match(arr) {
        arr.find((element) => {
          if (element.includes("Video Verification")) {
            return true;
          }
        });
      },
      /* Download CSV*/

      downloadCsv() {
        console.log("methods_18");
        let loan_step = this.filters.loan_steps
          ? "step_" + this.filters.loan_steps.replace(/ /g, "_").toLowerCase()
          : null;
        if (loan_step == "step_in_video_verification") {
          loan_step = "step_in_person_verification";
        }
        let url = this.$urls.BASE_URL + this.$urls.CUSTOMER_LIST_CSV + "?";
        if (this.filters.loan_status)
          url += "?loan_status=" + this.filters.loan_status;
        if (loan_step) url += "&loan_step=" + loan_step;
        if (this.filters.profile_status)
          url += "&user_profile_status=" + this.filters.profile_status;
        if (this.filters.date_range[0])
          url += "&from_date=" + this.filters.date_range[0];
        if (this.filters.date_range[1])
          url += "&to_date=" + this.filters.date_range[1];
        if (this.filters.current_city)
          url += "&city=" + this.filters.current_city;

        window.open(url, "_blank");
      },
      /* unloack the kYC CSV*/
      unLockKyc(customer_id) {
        const self = this;
        var form = new FormData();
        form.append("user_id", customer_id);
        const successHandler = (response) => {
          if (response.data.success) {
            self.showSnakeBar("success", "KYC Attempt Unlocked");
            self.getCustomerList();
          }
        };
        const finallyHandler = () => {
          self.login_loading = false;
        };
        this.request_POST(
          self,
          this.$urls.UNBLOCK_KYC,
          form,
          successHandler,
          null,
          null,
          finallyHandler
        );
      },
    },
  };
</script>
